<template>
  <div class="link">
    <Link msg="Link"/>
  </div>
</template>

<script>
  // @ is an alias to /src
  import Link from '@/components/Link.vue';

  export default {
    name: 'link',
    components: {
      Link,
    },
  };
</script>
